import { makePage } from '@keystatic/remix/ui'
import config from '../../../keystatic.config'

export default makePage(config)
